// @docs https://master.content-static.sandbox.d2c.r-one.io/docs#/FAQ%20Articles/FaqArticlesV2Controller_readByProviderId

import { ERequestMethod } from '@r1-frontend/api-domru/core/types/ERequestMethod';
import { IRequestParams } from '@r1-frontend/api-domru/src/content-static/dto/RequestDto';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

export const getArticlesByPlace = ({ providerId, placeAlias }: IRequestParams): IRequest => ({
    uri: `/api/v2/${providerId}/faq/articles`,
    method: ERequestMethod.GET,
    queryParams: {
        'filter[isActive]': true,
        'filter[place][alias]': placeAlias,
        'filter[platform]': 'web',
    },
    headers: {
        providerId: `${providerId}`,
    },
});
